import { defineMessages } from 'react-intl';

export const giftCardCheckoutMessages = defineMessages({
  errorBannerText: {
    defaultMessage: 'Unable to purchase gift card. Please try again later.',
    description: 'Gift Card Checkout | Submission | Failed submission banner text',
  },
  paymentErrorBannerText: {
    defaultMessage:
      'We were unable to bill your order. Please check that your card on file is valid.',
    description: 'Gift Card Checkout | Submission | Payment failure banner text',
  },
});
